/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BalanceEntryResponse
 */
export interface BalanceEntryResponse {
    /**
     * 
     * @type {string}
     * @memberof BalanceEntryResponse
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof BalanceEntryResponse
     */
    claimId: string;
    /**
     * 
     * @type {Date}
     * @memberof BalanceEntryResponse
     */
    date: Date;
    /**
     * 
     * @type {number}
     * @memberof BalanceEntryResponse
     */
    amount: number;
    /**
     * 
     * @type {string}
     * @memberof BalanceEntryResponse
     */
    entryType: string | null;
}

/**
 * Check if a given object implements the BalanceEntryResponse interface.
 */
export function instanceOfBalanceEntryResponse(value: object): value is BalanceEntryResponse {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('claimId' in value) || value['claimId'] === undefined) return false;
    if (!('date' in value) || value['date'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    if (!('entryType' in value) || value['entryType'] === undefined) return false;
    return true;
}

export function BalanceEntryResponseFromJSON(json: any): BalanceEntryResponse {
    return BalanceEntryResponseFromJSONTyped(json, false);
}

export function BalanceEntryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): BalanceEntryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'claimId': json['claimId'],
        'date': (new Date(json['date'])),
        'amount': json['amount'],
        'entryType': json['entryType'],
    };
}

export function BalanceEntryResponseToJSON(json: any): BalanceEntryResponse {
    return BalanceEntryResponseToJSONTyped(json, false);
}

export function BalanceEntryResponseToJSONTyped(value?: BalanceEntryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'claimId': value['claimId'],
        'date': `${value['date'].getFullYear()}-${String(value['date'].getMonth()+1).padStart(2,'0')}-${String(value['date'].getDate()).padStart(2,'0')}`,
        'amount': value['amount'],
        'entryType': value['entryType'],
    };
}

